module.exports = __webpack_public_path__ + "static/media/victor-freitas-546919-unsplash.b333a806.png";